/* ============
 * Vuex Actions
 * ============
 *
 * All the actions that can be used
 * inside the store
 */
import * as types from './mutation-types';

// Account
export const getAccount = ({ commit }, account) => {
  commit(types.GET_ACCOUNT, account);
};

// URL Lookup
export const getURLLookup = ({ commit }, ulresp) => {
  commit(types.URL_LOOKUP, ulresp);
};

// Auth
export const login = ({ commit }, token) => {
  commit(types.LOGIN, token);
};

// Select customer
export const selectSP = ({ commit }, customerID) => {
  commit(types.SELECT_CUSTOMER, customerID);
};

export const logout = ({ commit }) => {
  commit(types.LOGOUT);
};

export const getAllLists = ({ commit }, lists) => {
  commit(types.GET_ALL_LISTS, lists);
};

export const getList = ({ commit }, list) => {
  commit(types.GET_LIST, list);
};

export const getUsers = ({ commit }, list) => {
  commit(types.GET_USERS, list);
};

export const getUser = ({ commit }, data) => {
  commit(types.GET_USER, data);
};

export const getListEntries = ({ commit }, listentries) => {
  commit(types.GET_LIST_ENTRIES, listentries);
};

export const setListEntry = ({ commit }, updateObj) => {
  commit(types.SET_LIST_ENTRY, updateObj);
};

export const checkAuthentication = ({ commit }) => {
  commit(types.CHECK_AUTHENTICATION);
};



// WEBPACK FOOTER //
// ./src/app/store/actions.js